import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About CN Terminal Company Limited</h2>
            <p className="about-description">
              CN Terminal Company Limited is a licensed Customs House Agency that plays a significant role in multiple sectors of the shipping industry. The company has demonstrated consistent growth in its operations, revenue, and workforce. Additionally, it has developed global partnerships and broadened its international clientele, enhancing its presence in the global market.
            </p>
            
            <div className="about-stats">
              <div className="stat">
                <div className="stat-number">Licensed</div>
                <div className="stat-label">Customs House Agency</div>
              </div>
              <div className="stat">
                <div className="stat-number">Global</div>
                <div className="stat-label">Partnerships</div>
              </div>
              <div className="stat">
                <div className="stat-number">Growing</div>
                <div className="stat-label">International Clientele</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
